<template>
  <el-dialog width="40%" title="纠错" :visible="visible" @close="closeDialog">
    <el-form
      :model="requestData"
      style="height: 500px; overflow: auto"
      label-position="left"
      label-width="150px"
    >
      <el-form-item label="迁出地（古地名）">
        <el-input
          v-model="requestData.beginAncientPlaceName"
          :placeholder="errorData.beginPlace"
        ></el-input>
      </el-form-item>
      <el-form-item label="迁出地（现行政区划地址）">
        <el-input
          v-model="requestData.beginNowPlaceAddress"
          :placeholder="errorData.beginPlaceAddress"
        ></el-input>
      </el-form-item>
      <el-form-item label="迁入地（古地名）">
        <el-input
          v-model="requestData.endAncientPlaceName"
          :placeholder="errorData.endPlace"
        ></el-input>
      </el-form-item>
      <el-form-item label="迁入地（现行政区划地址）">
        <el-input
          v-model="requestData.endNowPlaceAddress"
          :placeholder="errorData.endPlaceAddress"
        ></el-input>
      </el-form-item>
      <el-form-item label="纠错依据">
        <el-upload
          action="/"
          list-type="picture-card"
          :on-change="uploadChange"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          multiple
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="requestData.correctRemark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onconfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadImage, areaCorrect } from "@/api/drillingIn";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    errorData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fileList: [],
      requestData: {
        correctRemark: "",
        beginAncientPlaceName: null,
        beginNowPlaceAddress: null,
        endAncientPlaceName: null,
        endNowPlaceAddress: null,
      },
    };
  },
  methods: {
    handleRemove(file,fileList){
      this.fileList = fileList;
    },
    closeDialog() {
      this.requestData = {
        correctRemark: "",
        beginAncientPlaceName: null,
        beginNowPlaceAddress: null,
        endAncientPlaceName: null,
        endNowPlaceAddress: null,
      };
      this.$emit("update:visible", false);
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    onconfirm() {
      const formData = new FormData();
      this.fileList.forEach((file) => {
        if (file.raw) {
          formData.append("formFiles", file.raw);
        }
      });
      uploadImage(formData, { uploadType: 3 })
        .then((res) => {
          areaCorrect({
            ...this.requestData,
            personalMigrateInfoId: this.errorData.personalMigrateInfoId,
            personalMigrateDetailId:this.errorData.personalMigrateDetailId,
            bases: res,
          });
        })
        .then(() => {
          this.$message.success("操作成功");
          this.closeDialog();
        })
        .catch((e) => {
          console.error(e);
          this.$message.error("操作失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
